import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { LEGACY_EMPLOYEES_DASHBOARD_PATH, WORKERS_DASHBOARD_PATH } from './constants';
import { useEmployeesDashboardRoute } from './routing';
import { READ_EMPLOYEE_DASHBOARD } from 'domain/shared/employee';
import EmployeesDashboard from './List/EmployeesDashboard';

const LegacyEmployeesDashboardRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const targetPath = pathname.replace(LEGACY_EMPLOYEES_DASHBOARD_PATH, WORKERS_DASHBOARD_PATH);

  return <Navigate to={`${targetPath}${search}${hash}`} replace />;
};

const EmployeesDashboardRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useEmployeesDashboardRoute();

  return (
    <ProtectedRouter basePath={WORKERS_DASHBOARD_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_EMPLOYEE_DASHBOARD}>
              <EmployeesDashboard />
            </GlobalProtectedRoute>
          }
        />
        <Route path={`${LEGACY_EMPLOYEES_DASHBOARD_PATH}/*`} element={<LegacyEmployeesDashboardRedirect />} />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

EmployeesDashboardRouter.getRouterPath = () => `${WORKERS_DASHBOARD_PATH}/*`;

export default EmployeesDashboardRouter;
